<div class="clear-auto-complete-wrap" *ngIf="!mapGeo?.lookUpGoogle">
    <button type="button" [id]="'btnRemove'+keyName" mat-button class="close-icon" (click)="removeStreet(null)" [disabled]="disabled">
        <mat-icon>close</mat-icon>
    </button>
    <mat-form-field appearance="standard">
        <input [id]="keyName+'InputAutoComplete'" matInput placeholder="Search address" [matAutocomplete]="autogeo" name="streetGeo"
        (input)="lookUp($event.target.value)"
        [readonly]="disabled" [ngStyle]="disabled ? {'cursor':'not-allowed'} : ''">
    </mat-form-field>
    <mat-autocomplete class="ft-geo-auto-complete" #autogeo="matAutocomplete" [displayWith]="getDisplayFn()"
        (optionSelected)="mapGeo.selectionOption($event.option.value)">
        <mat-option *ngFor="let street of streets" [value]="street">
            {{street.street}}
        </mat-option>
    </mat-autocomplete>
</div>


<div class="clear-auto-complete-wrap" *ngIf="mapGeo?.lookUpGoogle">

    <button type="button" [id]="'ggRemove'+keyName" mat-button class="close-icon" (click)="mapGeo.removeStreet()" [disabled]="disabled">
        <mat-icon>close</mat-icon>
    </button>
    <mat-form-field appearance="standard">
        <input matInput class="form-control-geo-auto-complete mat-input-element" [id]="keyName+'autocomplete'"
            (input)="lookUp($event.target.value)"
            placeholder="Search" type="text" [readonly]="disabled" [ngStyle]="disabled ? {'cursor':'not-allowed'} : ''">
    </mat-form-field>
</div>
